<template>
    <div class="container">
        <div class="container-bg"></div>
        <WaterfallView :shouye="false" />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';

import WaterfallView from '../../componets/waterfallView/index';
export default {
    components: {
        WaterfallView
    },
    mixins: [homemixin],

    data() {
        return {
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '生活权益',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
    },
    methods: {}
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';
.container {
    padding-top: 14px;
    width: 100%;
    &-bg {
        position: fixed;
        top: 0;
        width: 100%;
        left: 0;
        background: linear-gradient(360deg, rgba(255, 255, 255, 1) 0%, rgba(235, 246, 255, 1) 100%);
        height: 233px;
        z-index: -1;
    }
}
</style>
